<template>
<main v-if="showViewType" class="main-wrapper flex-grow-1 dildarKhan pdb-34">
	<div ref="surveyHeader">
		<view-header v-if="headerType === false" :endDate="endDate" :surveyData="surveyData" :todayDate="todayDate"></view-header>
		<view-header-insight v-else :endDate="endDate" :surveyData="surveyData" :todayDate="todayDate"></view-header-insight>
	</div>
		<!-- subtabs -->
		<view-tab v-if="headerType === false" @setViewTab="setViewTab"></view-tab>
		<!-- <div class="container container--narrow pdt-30"> -->
			<div class="container container--narrow pdt-30">
				<div v-if="campaignData && campaignData.image" class="mgb-24">
					<a v-if="campaignData.dynamicLink" :href="campaignData.dynamicLink.shortLink" class="d-block" target="_blank">
						<img :src="campaignData.image" alt="" class="b-radius4 survey-banner" />
					</a>
					<a v-else class="d-block" href="javascript:void(0)" style="cursor:none">
						<img v-if="campaignData.image" :src="campaignData.image" alt="" class="b-radius4 survey-banner" />
					</a>
				</div>
						<component
							:is="tabType"
							v-if="headerType === false"
							:badgesData="badgesData"
							:surveyData="surveyData"
						></component>
					<div v-if="headerType === true">
						<insight-view :headerType="true" :surveyData="surveyData"></insight-view>
					</div>
					<!-- <router-view></router-view> -->
		</div>
		</main>
	<div v-else>
		<router-view></router-view>
</div>
</template>

<script>
/**
 * 단독 설문 상세 메인 컴포넌트(independent survey view main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import surveyApi from "@/api/surveyApi.js";
import campaignApi from "@/api/campaignApi.js";
import ViewHeader from "./view/Header";
import ViewHeaderInsight from "./view/InsightHeader";
import ViewTab from "./view/ViewTab";
import ViewInformation from "./view/Information";
import ViewReward from "./view/Reward";
import { surveyMixin } from "@/mixins/survey.js";
import InsightViewVue from './InsightView.vue';

export default {
	name: "surveyTotalView",

	data() {
		return {
			surveyData: null,
			badgesData: null,
			tabType: "Information",
			campaignData: null,
			setTabFixed: false,
			headerType : false,
			showViewType: false,
			todayDate : null,
      endDate : null
		};
	},

	components: {
		"view-header": ViewHeader,
		"view-header-insight": ViewHeaderInsight,
		"view-tab": ViewTab,
		Information: ViewInformation,
		Reward: ViewReward,
		'insight-view': InsightViewVue,
	},

	mixins: [surveyMixin],

	watch:{
		$route (to, from){ 
				if(this.$route.query.listType === 'result'){
					if(this.$route.query.viewDetail === 'insightViewDetail'){
						this.headerType = false
					} else {
						this.headerType = true
					}
				} else {
					this.headerType = false
				}
		}
	},
	
	mounted() {
		if(this.$route.name === 'IndependentSurveyTotalView'){
			this.showViewType = true;
		} else{
			this.showViewType = false;
		}
		if(this.$route.query.listType === 'result') {
			if(this.$route.query.viewDetail === 'insightViewDetail') {
				this.headerType = false
			} else {
				this.headerType = true
			}
		} else {
			this.headerType = false
		}
		this.fatchData();
	},

	methods: {
		setViewTab(tabType) {
			this.tabType = tabType;
		},

		// 상세 데이터 호출(get survey information data)
		async fatchData() {
			let params = {
				distId: this.$route.params.distId,
			};
			// check auth & get survey information data
			let authStatus = await this.checkLogin();
			if (authStatus && this.$route.query.distributionType !== "SATISFACTION") {
				if(this.$route.query.listType === 'result') {
					let params1 = {
						distributionId: this.$route.params.distId,
					};
					surveyApi.surveyInsightView(params1).then((response) => {
						this.surveyData = response.data.data;
						this.todayDate = new Date();
            this.endDate = new Date(this.surveyData.application.end);
					});
				} else {
					surveyApi.surveyIndependentView(params).then((response) => {
						this.surveyData = response.data.data;
						this.todayDate = new Date();
            this.endDate = new Date(this.surveyData.application.end);
					});
				}
				
			} else {
					if (this.$route.query.distributionType !== "SATISFACTION") {
						if(this.$route.query.listType === 'result') {
						surveyApi.surveyInsightView(params).then((response) => {
							this.surveyData = response.data.data;
							this.todayDate = new Date();
              this.endDate = new Date(this.surveyData.application.end);
						});
					} else {
						surveyApi.guestSurveyIndependentView(params).then((response) => {
							this.surveyData = response.data.data;
							this.todayDate = new Date();
              this.endDate = new Date(this.surveyData.application.end);
						});
					}  
				}
			}

			// get survey badges list
			if (this.$route.query.distributionType !== "SATISFACTION") {
				surveyApi.guestSurveyIndependentViewBadges(params).then((response) => {
					this.badgesData = response.data.data;
				});
			}

			// get survey campaign data
			campaignApi
				.campaign({
					locationType: "IN_INDEPENDENT_SURVEY",
					locationValue: this.$route.params.distId,
				})
				.then((response) => {
					this.campaignData = response.data.data;
				})
				.catch((err) => {});
		},

		// 상하 스크롤 이동시 탭 고정(move up/down scroll fixed tab)
		scrollMove(el) {
			if (
				parseInt(el.scrollTop) >= parseInt(this.$refs.surveyHeader.offsetHeight)
			) {
        this.setTabFixed = true;
      } else {
				this.setTabFixed = false;
			}
		},
	},
};
</script>
